import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
  InputAdornment,
  Chip,
  Tooltip,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Card,
  CardContent,
  Stepper,
  Step,
  StepLabel,
  FormControlLabel,
  Checkbox,
  Divider,
  Avatar,
  LinearProgress,
} from "@mui/material";
import {
  Search as SearchIcon,
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as ViewIcon,
  Refresh as RefreshIcon,
  PersonAdd as PartnerIcon,
  Business as BusinessIcon,
  AccountBalance as BankIcon,
  VerifiedUser as VerifiedIcon,
  Description as DocumentIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  Home as AddressIcon,
  SupervisorAccount as SponsorIcon,
  TrendingUp as CommissionIcon,
  CheckCircle as ApprovedIcon,
  HourglassEmpty as PendingIcon,
  Cancel as RejectedIcon,
  Info as InfoIcon,
  AttachFile as AttachIcon,
  CloudUpload as UploadIcon,
} from "@mui/icons-material";

const PartnerRegistration = () => {
  // Sample partners data
  const [partners, setPartners] = useState([
    {
      id: 1,
      partnerCode: "PTR001",
      partnerName: "Suresh ",
      ownerName: "Suresh Kumar",
      partnerType: "Reseller",
      phone: "+91 98765 43210",
      email: "suresh@.com",
      city: "Mumbai",
      sponsorCode: "PTR000",
      sponsorName: "Direct",
      commissionPlan: "Standard - 10%",
      totalSales: 850000,
      totalCommission: 85000,
      outstandingCommission: 12000,
      kycStatus: "Verified",
      status: "Active",
      registrationDate: "2023-06-15",
    },
    {
      id: 2,
      partnerCode: "PTR002",
      partnerName: "Tech Solutions Hub",
      ownerName: "Priya Sharma",
      partnerType: "Affiliate",
      phone: "+91 98765 43211",
      email: "priya@techsolutions.com",
      city: "Bangalore",
      sponsorCode: "PTR001",
      sponsorName: "Suresh ",
      commissionPlan: "Affiliate - 5%",
      totalSales: 450000,
      totalCommission: 22500,
      outstandingCommission: 5000,
      kycStatus: "Pending",
      status: "Active",
      registrationDate: "2023-08-20",
    },
    {
      id: 3,
      partnerCode: "PTR003",
      partnerName: "Digital Commerce Pro",
      ownerName: "Amit Patel",
      partnerType: "Distributor",
      phone: "+91 98765 43212",
      email: "amit@digitalcommerce.com",
      city: "Ahmedabad",
      sponsorCode: "PTR000",
      sponsorName: "Direct",
      commissionPlan: "Distributor - 15%",
      totalSales: 1250000,
      totalCommission: 187500,
      outstandingCommission: 35000,
      kycStatus: "Verified",
      status: "Active",
      registrationDate: "2023-05-10",
    },
    {
      id: 4,
      partnerCode: "PTR004",
      partnerName: "Retail Connect",
      ownerName: "Sneha Desai",
      partnerType: "Reseller",
      phone: "+91 98765 43213",
      email: "sneha@retailconnect.com",
      city: "Pune",
      sponsorCode: "PTR003",
      sponsorName: "Digital Commerce Pro",
      commissionPlan: "Standard - 10%",
      totalSales: 320000,
      totalCommission: 32000,
      outstandingCommission: 8000,
      kycStatus: "Verified",
      status: "Active",
      registrationDate: "2023-09-15",
    },
    {
      id: 5,
      partnerCode: "PTR005",
      partnerName: "Sales Force India",
      ownerName: "Vikram Singh",
      partnerType: "Agent",
      phone: "+91 98765 43214",
      email: "vikram@salesforce.com",
      city: "Delhi",
      sponsorCode: "PTR001",
      sponsorName: "Suresh ",
      commissionPlan: "Agent - 7%",
      totalSales: 180000,
      totalCommission: 12600,
      outstandingCommission: 2600,
      kycStatus: "Pending",
      status: "Pending Approval",
      registrationDate: "2024-01-10",
    },
  ]);

  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [typeFilter, setTypeFilter] = useState("all");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [successMessage, setSuccessMessage] = useState("");
  const [errors, setErrors] = useState({});

  // Modal state
  const [openModal, setOpenModal] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [editingPartner, setEditingPartner] = useState(null);
  const [viewingPartner, setViewingPartner] = useState(null);
  const [activeStep, setActiveStep] = useState(0);

  // Form state
  const [partnerForm, setPartnerForm] = useState({
    partnerCode: "",
    // Basic Details
    partnerType: "Reseller",
    businessName: "",
    ownerName: "",
    phone: "",
    alternatePhone: "",
    email: "",
    website: "",
    // Address
    address: "",
    city: "",
    state: "",
    pincode: "",
    country: "India",
    // Business Details
    gstNumber: "",
    panNumber: "",
    businessType: "Proprietorship",
    yearEstablished: "",
    // Bank Details
    bankName: "",
    accountNumber: "",
    ifscCode: "",
    accountHolderName: "",
    branchName: "",
    // Sponsor Details
    sponsorCode: "",
    sponsorName: "",
    commissionPlan: "Standard - 10%",
    // Documents
    panCard: null,
    aadharCard: null,
    gstCertificate: null,
    cancelledCheque: null,
    // Agreement
    agreementAccepted: false,
    termsAccepted: false,
    status: "Pending Approval",
  });

  const steps = ["Basic Details", "Business Info", "Bank Details", "Sponsor & Commission", "Documents & Agreement"];

  // Helper functions
  const getFilteredPartners = () => {
    return partners.filter((partner) => {
      const matchesSearch = Object.values(partner).some((value) =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase())
      );
      const matchesStatus = statusFilter === "all" || partner.status === statusFilter;
      const matchesType = typeFilter === "all" || partner.partnerType === typeFilter;
      return matchesSearch && matchesStatus && matchesType;
    });
  };

  const getTypeColor = (type) => {
    switch (type) {
      case 'Distributor': return 'primary';
      case 'Reseller': return 'secondary';
      case 'Affiliate': return 'info';
      case 'Agent': return 'warning';
      default: return 'default';
    }
  };

  const getKYCColor = (status) => {
    switch (status) {
      case 'Verified': return { bg: '#e8f5e9', color: '#2e7d32' };
      case 'Pending': return { bg: '#fff3e0', color: '#e65100' };
      case 'Rejected': return { bg: '#ffebee', color: '#d32f2f' };
      default: return { bg: '#f5f5f5', color: '#666' };
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0,
    }).format(amount);
  };

  // Handlers
  const handleEdit = (partner) => {
    setEditingPartner(partner);
    setActiveStep(0);
    setOpenModal(true);
  };

  const handleView = (partner) => {
    setViewingPartner(partner);
    setOpenViewModal(true);
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this partner?")) {
      setPartners(partners.filter((partner) => partner.id !== id));
      setSuccessMessage("Partner deleted successfully!");
      setTimeout(() => setSuccessMessage(""), 3000);
    }
  };

  const handleChangePage = (_, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearch = () => {
    setPage(0);
    setSuccessMessage(`Search completed. Found ${getFilteredPartners().length} partners.`);
    setTimeout(() => setSuccessMessage(""), 3000);
  };

  const handleReset = () => {
    setSearchQuery("");
    setStatusFilter("all");
    setTypeFilter("all");
    setPage(0);
    setErrors({});
    setSuccessMessage("");
  };

  const handleOpenModal = () => {
    setEditingPartner(null);
    const newCode = `PTR${String(partners.length + 1).padStart(3, '0')}`;
    setPartnerForm({
      partnerCode: newCode,
      partnerType: "Reseller",
      businessName: "",
      ownerName: "",
      phone: "",
      alternatePhone: "",
      email: "",
      website: "",
      address: "",
      city: "",
      state: "",
      pincode: "",
      country: "India",
      gstNumber: "",
      panNumber: "",
      businessType: "Proprietorship",
      yearEstablished: "",
      bankName: "",
      accountNumber: "",
      ifscCode: "",
      accountHolderName: "",
      branchName: "",
      sponsorCode: "",
      sponsorName: "",
      commissionPlan: "Standard - 10%",
      panCard: null,
      aadharCard: null,
      gstCertificate: null,
      cancelledCheque: null,
      agreementAccepted: false,
      termsAccepted: false,
      status: "Pending Approval",
    });
    setActiveStep(0);
    setErrors({});
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setEditingPartner(null);
    setActiveStep(0);
    setErrors({});
  };

  const handleCloseViewModal = () => {
    setOpenViewModal(false);
    setViewingPartner(null);
  };

  const handleFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    setPartnerForm({
      ...partnerForm,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleFileChange = (e, fieldName) => {
    const file = e.target.files[0];
    setPartnerForm({ ...partnerForm, [fieldName]: file });
  };

  const validateStep = (step) => {
    const newErrors = {};

    if (step === 0) {
      if (!partnerForm.businessName) newErrors.businessName = "Business name is required";
      if (!partnerForm.ownerName) newErrors.ownerName = "Owner name is required";
      if (!partnerForm.phone) newErrors.phone = "Phone number is required";
      if (!partnerForm.email) newErrors.email = "Email is required";
      else if (!/\S+@\S+\.\S+/.test(partnerForm.email)) newErrors.email = "Invalid email format";
    }

    if (step === 1) {
      if (!partnerForm.panNumber) newErrors.panNumber = "PAN number is required";
      if (!partnerForm.address) newErrors.address = "Address is required";
      if (!partnerForm.city) newErrors.city = "City is required";
    }

    if (step === 2) {
      if (!partnerForm.bankName) newErrors.bankName = "Bank name is required";
      if (!partnerForm.accountNumber) newErrors.accountNumber = "Account number is required";
      if (!partnerForm.ifscCode) newErrors.ifscCode = "IFSC code is required";
    }

    if (step === 4) {
      if (!partnerForm.agreementAccepted) newErrors.agreementAccepted = "Please accept the partner agreement";
      if (!partnerForm.termsAccepted) newErrors.termsAccepted = "Please accept terms and conditions";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    if (validateStep(activeStep)) {
      setActiveStep((prevStep) => prevStep + 1);
    }
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const handleSavePartner = () => {
    if (!validateStep(activeStep)) return;

    const newPartner = {
      id: editingPartner ? editingPartner.id : partners.length + 1,
      partnerCode: partnerForm.partnerCode,
      partnerName: partnerForm.businessName,
      ownerName: partnerForm.ownerName,
      partnerType: partnerForm.partnerType,
      phone: partnerForm.phone,
      email: partnerForm.email,
      city: partnerForm.city,
      sponsorCode: partnerForm.sponsorCode || "PTR000",
      sponsorName: partnerForm.sponsorName || "Direct",
      commissionPlan: partnerForm.commissionPlan,
      totalSales: editingPartner ? editingPartner.totalSales : 0,
      totalCommission: editingPartner ? editingPartner.totalCommission : 0,
      outstandingCommission: editingPartner ? editingPartner.outstandingCommission : 0,
      kycStatus: "Pending",
      status: partnerForm.status,
      registrationDate: editingPartner ? editingPartner.registrationDate : new Date().toISOString().split('T')[0],
    };

    if (editingPartner) {
      setPartners(partners.map(p => p.id === editingPartner.id ? newPartner : p));
      setSuccessMessage("Partner updated successfully!");
    } else {
      setPartners([newPartner, ...partners]);
      setSuccessMessage("Partner registration submitted successfully! Pending approval.");
    }

    handleCloseModal();
    setTimeout(() => setSuccessMessage(""), 3000);
  };

  const filteredPartners = getFilteredPartners();

  // Calculate statistics
  const totalPartners = partners.length;
  const activePartners = partners.filter(p => p.status === "Active").length;
  const totalSales = partners.reduce((sum, p) => sum + p.totalSales, 0);
  const totalCommission = partners.reduce((sum, p) => sum + p.totalCommission, 0);

  // Get unique values for filters
  const partnerTypes = [...new Set(partners.map(p => p.partnerType))];

  return (
    <Box sx={{ p: 3 }}>
      {/* Header Section */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <PartnerIcon sx={{ color: 'primary.main', fontSize: 40 }} />
          <Box>
            <Typography variant="h4" fontWeight="bold" color="primary">
              Sales Partner Management
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Register and manage resellers, distributors & affiliates • {filteredPartners.length} partners
            </Typography>
          </Box>
        </Box>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleOpenModal}
          sx={{
            borderRadius: 2,
            px: 3,
            py: 1,
            fontWeight: 600,
            backgroundColor: 'primary.main',
            '&:hover': {
              backgroundColor: 'primary.dark',
            },
          }}
        >
          Register Partner
        </Button>
      </Box>

      {/* Success Message */}
      {successMessage && (
        <Alert severity="success" sx={{ mb: 2, borderRadius: 2 }}>
          {successMessage}
        </Alert>
      )}

      {/* Statistics Cards */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ borderRadius: 2, boxShadow: 2, borderLeft: '4px solid #1976d2' }}>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="caption" color="text.secondary">Total Partners</Typography>
                  <Typography variant="h4" fontWeight="bold" color="primary.main">
                    {totalPartners}
                  </Typography>
                </Box>
                <BusinessIcon sx={{ fontSize: 48, color: 'primary.main', opacity: 0.3 }} />
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ borderRadius: 2, boxShadow: 2, borderLeft: '4px solid #2e7d32' }}>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="caption" color="text.secondary">Active Partners</Typography>
                  <Typography variant="h4" fontWeight="bold" color="success.main">
                    {activePartners}
                  </Typography>
                </Box>
                <ApprovedIcon sx={{ fontSize: 48, color: 'success.main', opacity: 0.3 }} />
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ borderRadius: 2, boxShadow: 2, borderLeft: '4px solid #9c27b0' }}>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="caption" color="text.secondary">Total Sales</Typography>
                  <Typography variant="h6" fontWeight="bold" color="secondary.main">
                    {formatCurrency(totalSales)}
                  </Typography>
                </Box>
                <CommissionIcon sx={{ fontSize: 48, color: 'secondary.main', opacity: 0.3 }} />
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ borderRadius: 2, boxShadow: 2, borderLeft: '4px solid #ff9800' }}>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="caption" color="text.secondary">Total Commission</Typography>
                  <Typography variant="h6" fontWeight="bold" color="warning.main">
                    {formatCurrency(totalCommission)}
                  </Typography>
                </Box>
                <CommissionIcon sx={{ fontSize: 48, color: 'warning.main', opacity: 0.3 }} />
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Search and Filter Section */}
      <Paper sx={{ p: 3, mb: 3, borderRadius: 2, boxShadow: 2 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Search Partners..."
              variant="outlined"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <TextField
              select
              fullWidth
              label="Partner Type"
              value={typeFilter}
              onChange={(e) => setTypeFilter(e.target.value)}
              SelectProps={{ native: true }}
            >
              <option value="all">All Types</option>
              {partnerTypes.map((type) => (
                <option key={type} value={type}>{type}</option>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} md={2}>
            <TextField
              select
              fullWidth
              label="Status"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              SelectProps={{ native: true }}
            >
              <option value="all">All Status</option>
              <option value="Active">Active</option>
              <option value="Pending Approval">Pending Approval</option>
              <option value="Inactive">Inactive</option>
            </TextField>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button variant="contained" onClick={handleSearch} startIcon={<SearchIcon />} sx={{ flex: 1 }}>
                Search
              </Button>
              <Button variant="outlined" onClick={handleReset} startIcon={<RefreshIcon />} sx={{ flex: 1 }}>
                Reset
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      {/* Table Section */}
      <Paper sx={{ borderRadius: 2, boxShadow: 3, overflow: 'hidden' }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#f8f9fa' }}>
                <TableCell sx={{ fontWeight: 'bold' }}>Partner Code</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Partner Details</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Type</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Sponsor</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Total Sales</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Commission</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>KYC Status</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }} align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredPartners.length > 0 ? (
                filteredPartners.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((partner) => {
                  const kycStyle = getKYCColor(partner.kycStatus);
                  return (
                    <TableRow key={partner.id} sx={{ '&:hover': { backgroundColor: '#f5f5f5' } }}>
                      <TableCell>
                        <Typography variant="body2" fontWeight="600" sx={{ fontFamily: 'monospace' }}>
                          {partner.partnerCode}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Avatar sx={{ bgcolor: 'primary.main', width: 32, height: 32 }}>
                            {partner.partnerName.charAt(0)}
                          </Avatar>
                          <Box>
                            <Typography variant="body2" fontWeight="600">{partner.partnerName}</Typography>
                            <Typography variant="caption" color="text.secondary">{partner.ownerName}</Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={partner.partnerType}
                          size="small"
                          color={getTypeColor(partner.partnerType)}
                          sx={{ fontWeight: 500 }}
                        />
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <SponsorIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
                          <Typography variant="caption">{partner.sponsorName}</Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" fontWeight="600" color="secondary.main">
                          {formatCurrency(partner.totalSales)}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Box>
                          <Typography variant="body2" fontWeight="600" color="warning.main">
                            {formatCurrency(partner.totalCommission)}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            Due: {formatCurrency(partner.outstandingCommission)}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={partner.kycStatus}
                          size="small"
                          sx={{
                            backgroundColor: kycStyle.bg,
                            color: kycStyle.color,
                            fontWeight: 600,
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={partner.status}
                          size="small"
                          sx={{
                            backgroundColor: partner.status === 'Active' ? '#e8f5e9' : partner.status === 'Pending Approval' ? '#fff3e0' : '#ffebee',
                            color: partner.status === 'Active' ? '#2e7d32' : partner.status === 'Pending Approval' ? '#e65100' : '#d32f2f',
                            fontWeight: 600,
                          }}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                          <Tooltip title="View Details">
                            <IconButton size="small" onClick={() => handleView(partner)} sx={{ color: 'info.main' }}>
                              <ViewIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Edit">
                            <IconButton size="small" onClick={() => handleEdit(partner)} sx={{ color: 'warning.main' }}>
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete">
                            <IconButton size="small" onClick={() => handleDelete(partner.id)} sx={{ color: 'error.main' }}>
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={9} align="center" sx={{ py: 4 }}>
                    <PartnerIcon sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />
                    <Typography variant="body1" color="text.secondary">No partners found</Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={filteredPartners.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50]}
        />
      </Paper>

      {/* Registration Modal with Stepper */}
      <Dialog open={openModal} onClose={handleCloseModal} maxWidth="md" fullWidth>
        <DialogTitle sx={{
          backgroundColor: 'primary.main',
          color: 'white',
          padding: '16px 24px',
        }}>
          <Typography variant="h6" sx={{ color: 'white', display: 'flex', alignItems: 'center', gap: 1 }}>
            <PartnerIcon /> {editingPartner ? 'Edit Partner' : 'Partner Registration'}
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ padding: '24px', mt: 2 }}>
          <Stepper activeStep={activeStep} sx={{ mb: 4 }}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>

          {/* Step 0: Basic Details */}
          {activeStep === 0 && (
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Partner Code" value={partnerForm.partnerCode} disabled />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>Partner Type *</InputLabel>
                  <Select
                    name="partnerType"
                    value={partnerForm.partnerType}
                    onChange={handleFormChange}
                    label="Partner Type *"
                  >
                    <MenuItem value="Distributor">Distributor</MenuItem>
                    <MenuItem value="Reseller">Reseller</MenuItem>
                    <MenuItem value="Affiliate">Affiliate</MenuItem>
                    <MenuItem value="Agent">Agent</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Business Name *"
                  name="businessName"
                  value={partnerForm.businessName}
                  onChange={handleFormChange}
                  error={!!errors.businessName}
                  helperText={errors.businessName}
                  InputProps={{
                    startAdornment: <InputAdornment position="start"><BusinessIcon /></InputAdornment>
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Owner Name *"
                  name="ownerName"
                  value={partnerForm.ownerName}
                  onChange={handleFormChange}
                  error={!!errors.ownerName}
                  helperText={errors.ownerName}
                  InputProps={{
                    startAdornment: <InputAdornment position="start"><PartnerIcon /></InputAdornment>
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Phone Number *"
                  name="phone"
                  value={partnerForm.phone}
                  onChange={handleFormChange}
                  error={!!errors.phone}
                  helperText={errors.phone}
                  placeholder="+91 98765 43210"
                  InputProps={{
                    startAdornment: <InputAdornment position="start"><PhoneIcon /></InputAdornment>
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Alternate Phone"
                  name="alternatePhone"
                  value={partnerForm.alternatePhone}
                  onChange={handleFormChange}
                  InputProps={{
                    startAdornment: <InputAdornment position="start"><PhoneIcon /></InputAdornment>
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Email Address *"
                  name="email"
                  type="email"
                  value={partnerForm.email}
                  onChange={handleFormChange}
                  error={!!errors.email}
                  helperText={errors.email}
                  InputProps={{
                    startAdornment: <InputAdornment position="start"><EmailIcon /></InputAdornment>
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Website"
                  name="website"
                  value={partnerForm.website}
                  onChange={handleFormChange}
                  placeholder="www.example.com"
                />
              </Grid>
            </Grid>
          )}

          {/* Step 1: Business Info */}
          {activeStep === 1 && (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Business Address *"
                  name="address"
                  value={partnerForm.address}
                  onChange={handleFormChange}
                  error={!!errors.address}
                  helperText={errors.address}
                  multiline
                  rows={2}
                  InputProps={{
                    startAdornment: <InputAdornment position="start"><AddressIcon /></InputAdornment>
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="City *"
                  name="city"
                  value={partnerForm.city}
                  onChange={handleFormChange}
                  error={!!errors.city}
                  helperText={errors.city}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="State"
                  name="state"
                  value={partnerForm.state}
                  onChange={handleFormChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Pincode"
                  name="pincode"
                  value={partnerForm.pincode}
                  onChange={handleFormChange}
                  placeholder="400001"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Country"
                  name="country"
                  value={partnerForm.country}
                  onChange={handleFormChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="PAN Number *"
                  name="panNumber"
                  value={partnerForm.panNumber}
                  onChange={handleFormChange}
                  error={!!errors.panNumber}
                  helperText={errors.panNumber}
                  placeholder="ABCDE1234F"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="GST Number"
                  name="gstNumber"
                  value={partnerForm.gstNumber}
                  onChange={handleFormChange}
                  placeholder="22AAAAA0000A1Z5"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>Business Type</InputLabel>
                  <Select
                    name="businessType"
                    value={partnerForm.businessType}
                    onChange={handleFormChange}
                    label="Business Type"
                  >
                    <MenuItem value="Proprietorship">Proprietorship</MenuItem>
                    <MenuItem value="Partnership">Partnership</MenuItem>
                    <MenuItem value="Private Limited">Private Limited</MenuItem>
                    <MenuItem value="LLP">LLP</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Year Established"
                  name="yearEstablished"
                  type="number"
                  value={partnerForm.yearEstablished}
                  onChange={handleFormChange}
                  placeholder="2020"
                />
              </Grid>
            </Grid>
          )}

          {/* Step 2: Bank Details */}
          {activeStep === 2 && (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Alert severity="info" sx={{ mb: 2 }}>
                  Bank details are required for commission payments
                </Alert>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Bank Name *"
                  name="bankName"
                  value={partnerForm.bankName}
                  onChange={handleFormChange}
                  error={!!errors.bankName}
                  helperText={errors.bankName}
                  InputProps={{
                    startAdornment: <InputAdornment position="start"><BankIcon /></InputAdornment>
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Account Holder Name"
                  name="accountHolderName"
                  value={partnerForm.accountHolderName}
                  onChange={handleFormChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Account Number *"
                  name="accountNumber"
                  value={partnerForm.accountNumber}
                  onChange={handleFormChange}
                  error={!!errors.accountNumber}
                  helperText={errors.accountNumber}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="IFSC Code *"
                  name="ifscCode"
                  value={partnerForm.ifscCode}
                  onChange={handleFormChange}
                  error={!!errors.ifscCode}
                  helperText={errors.ifscCode}
                  placeholder="SBIN0001234"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Branch Name"
                  name="branchName"
                  value={partnerForm.branchName}
                  onChange={handleFormChange}
                />
              </Grid>
            </Grid>
          )}

          {/* Step 3: Sponsor & Commission */}
          {activeStep === 3 && (
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Sponsor Code"
                  name="sponsorCode"
                  value={partnerForm.sponsorCode}
                  onChange={handleFormChange}
                  placeholder="PTR001 (Optional - Direct if empty)"
                  InputProps={{
                    startAdornment: <InputAdornment position="start"><SponsorIcon /></InputAdornment>
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Sponsor Name"
                  name="sponsorName"
                  value={partnerForm.sponsorName}
                  onChange={handleFormChange}
                  placeholder="Will be auto-filled"
                  disabled
                />
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel>Commission Plan</InputLabel>
                  <Select
                    name="commissionPlan"
                    value={partnerForm.commissionPlan}
                    onChange={handleFormChange}
                    label="Commission Plan"
                  >
                    <MenuItem value="Distributor - 15%">Distributor - 15%</MenuItem>
                    <MenuItem value="Standard - 10%">Standard - 10%</MenuItem>
                    <MenuItem value="Agent - 7%">Agent - 7%</MenuItem>
                    <MenuItem value="Affiliate - 5%">Affiliate - 5%</MenuItem>
                    <MenuItem value="Custom">Custom Plan</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Paper sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                  <Typography variant="body2" fontWeight="600" gutterBottom>
                    Commission Structure:
                  </Typography>
                  <Typography variant="caption" color="text.secondary" display="block">
                    • Distributor: 15% commission on all sales
                  </Typography>
                  <Typography variant="caption" color="text.secondary" display="block">
                    • Reseller: 10% commission on all sales
                  </Typography>
                  <Typography variant="caption" color="text.secondary" display="block">
                    • Agent: 7% commission on all sales
                  </Typography>
                  <Typography variant="caption" color="text.secondary" display="block">
                    • Affiliate: 5% commission on referred sales
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          )}

          {/* Step 4: Documents & Agreement */}
          {activeStep === 4 && (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                  Upload Documents
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, border: '1px dashed #ccc' }}>
                  <Typography variant="caption" color="text.secondary">PAN Card *</Typography>
                  <Button
                    component="label"
                    fullWidth
                    startIcon={<UploadIcon />}
                    sx={{ mt: 1 }}
                  >
                    Upload PAN
                    <input type="file" hidden onChange={(e) => handleFileChange(e, 'panCard')} />
                  </Button>
                  {partnerForm.panCard && (
                    <Typography variant="caption" color="success.main" display="block" sx={{ mt: 1 }}>
                      ✓ {partnerForm.panCard.name}
                    </Typography>
                  )}
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, border: '1px dashed #ccc' }}>
                  <Typography variant="caption" color="text.secondary">Aadhar Card *</Typography>
                  <Button
                    component="label"
                    fullWidth
                    startIcon={<UploadIcon />}
                    sx={{ mt: 1 }}
                  >
                    Upload Aadhar
                    <input type="file" hidden onChange={(e) => handleFileChange(e, 'aadharCard')} />
                  </Button>
                  {partnerForm.aadharCard && (
                    <Typography variant="caption" color="success.main" display="block" sx={{ mt: 1 }}>
                      ✓ {partnerForm.aadharCard.name}
                    </Typography>
                  )}
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, border: '1px dashed #ccc' }}>
                  <Typography variant="caption" color="text.secondary">GST Certificate</Typography>
                  <Button
                    component="label"
                    fullWidth
                    startIcon={<UploadIcon />}
                    sx={{ mt: 1 }}
                  >
                    Upload GST
                    <input type="file" hidden onChange={(e) => handleFileChange(e, 'gstCertificate')} />
                  </Button>
                  {partnerForm.gstCertificate && (
                    <Typography variant="caption" color="success.main" display="block" sx={{ mt: 1 }}>
                      ✓ {partnerForm.gstCertificate.name}
                    </Typography>
                  )}
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, border: '1px dashed #ccc' }}>
                  <Typography variant="caption" color="text.secondary">Cancelled Cheque *</Typography>
                  <Button
                    component="label"
                    fullWidth
                    startIcon={<UploadIcon />}
                    sx={{ mt: 1 }}
                  >
                    Upload Cheque
                    <input type="file" hidden onChange={(e) => handleFileChange(e, 'cancelledCheque')} />
                  </Button>
                  {partnerForm.cancelledCheque && (
                    <Typography variant="caption" color="success.main" display="block" sx={{ mt: 1 }}>
                      ✓ {partnerForm.cancelledCheque.name}
                    </Typography>
                  )}
                </Paper>
              </Grid>

              <Grid item xs={12}>
                <Divider sx={{ my: 2 }} />
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                  Agreement & Terms
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Paper sx={{ p: 2, bgcolor: '#f5f5f5', maxHeight: 200, overflow: 'auto' }}>
                  <Typography variant="body2" paragraph>
                    <strong>Partner Agreement</strong>
                  </Typography>
                  <Typography variant="caption" color="text.secondary" paragraph>
                    1. The partner agrees to promote and sell products as per company guidelines.
                  </Typography>
                  <Typography variant="caption" color="text.secondary" paragraph>
                    2. Commission will be paid monthly based on actual sales.
                  </Typography>
                  <Typography variant="caption" color="text.secondary" paragraph>
                    3. Partners must maintain accurate records and comply with all regulations.
                  </Typography>
                  <Typography variant="caption" color="text.secondary" paragraph>
                    4. Either party may terminate this agreement with 30 days notice.
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="agreementAccepted"
                      checked={partnerForm.agreementAccepted}
                      onChange={handleFormChange}
                    />
                  }
                  label="I accept the Partner Agreement *"
                />
                {errors.agreementAccepted && (
                  <Typography variant="caption" color="error.main" display="block">
                    {errors.agreementAccepted}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="termsAccepted"
                      checked={partnerForm.termsAccepted}
                      onChange={handleFormChange}
                    />
                  }
                  label="I accept the Terms and Conditions *"
                />
                {errors.termsAccepted && (
                  <Typography variant="caption" color="error.main" display="block">
                    {errors.termsAccepted}
                  </Typography>
                )}
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions sx={{ padding: '16px 24px', gap: 1 }}>
          <Button onClick={handleCloseModal}>Cancel</Button>
          {activeStep > 0 && (
            <Button onClick={handleBack}>Back</Button>
          )}
          {activeStep < steps.length - 1 ? (
            <Button
              variant="contained"
              onClick={handleNext}
              sx={{
                backgroundColor: 'primary.main',
                '&:hover': { backgroundColor: 'primary.dark' },
              }}
            >
              Next
            </Button>
          ) : (
            <Button
              variant="contained"
              onClick={handleSavePartner}
              sx={{
                backgroundColor: 'primary.main',
                '&:hover': { backgroundColor: 'primary.dark' },
              }}
            >
              Submit Registration
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* View Partner Modal */}
      <Dialog open={openViewModal} onClose={handleCloseViewModal} maxWidth="md" fullWidth>
        <DialogTitle sx={{
          backgroundColor: 'primary.main',
          color: 'white',
        }}>
          <Typography variant="h6" sx={{ color: 'white', display: 'flex', alignItems: 'center', gap: 1 }}>
            <InfoIcon /> Partner Details
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          {viewingPartner && (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                  <Avatar sx={{ bgcolor: 'primary.main', width: 56, height: 56, fontSize: '1.5rem' }}>
                    {viewingPartner.partnerName.charAt(0)}
                  </Avatar>
                  <Box>
                    <Typography variant="h6" fontWeight="bold">{viewingPartner.partnerName}</Typography>
                    <Box sx={{ display: 'flex', gap: 1, mt: 0.5 }}>
                      <Chip label={viewingPartner.partnerType} size="small" color={getTypeColor(viewingPartner.partnerType)} />
                      <Chip label={viewingPartner.status} size="small" color="success" />
                    </Box>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, bgcolor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption">Partner Code</Typography>
                  <Typography variant="body1" fontWeight="bold" sx={{ fontFamily: 'monospace' }}>
                    {viewingPartner.partnerCode}
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, bgcolor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption">Owner Name</Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {viewingPartner.ownerName}
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, bgcolor: 'rgba(156, 39, 176, 0.05)' }}>
                  <Typography variant="caption">Total Sales</Typography>
                  <Typography variant="h6" fontWeight="bold" color="secondary.main">
                    {formatCurrency(viewingPartner.totalSales)}
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, bgcolor: 'rgba(255, 152, 0, 0.05)' }}>
                  <Typography variant="caption">Total Commission</Typography>
                  <Typography variant="h6" fontWeight="bold" color="warning.main">
                    {formatCurrency(viewingPartner.totalCommission)}
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, bgcolor: 'rgba(76, 175, 80, 0.05)' }}>
                  <Typography variant="caption">Commission Plan</Typography>
                  <Typography variant="body1" fontWeight="bold" color="success.main">
                    {viewingPartner.commissionPlan}
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, bgcolor: 'rgba(244, 67, 54, 0.05)' }}>
                  <Typography variant="caption">Outstanding</Typography>
                  <Typography variant="h6" fontWeight="bold" color="error.main">
                    {formatCurrency(viewingPartner.outstandingCommission)}
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, bgcolor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption">Sponsor</Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {viewingPartner.sponsorName}
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, bgcolor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption">KYC Status</Typography>
                  <Box sx={{ mt: 1 }}>
                    <Chip
                      label={viewingPartner.kycStatus}
                      sx={{
                        bgcolor: getKYCColor(viewingPartner.kycStatus).bg,
                        color: getKYCColor(viewingPartner.kycStatus).color
                      }}
                    />
                  </Box>
                </Paper>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2.5 }}>
          <Button onClick={handleCloseViewModal}>Close</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default PartnerRegistration;

